<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>

		<main-content>
			<template #content>
				<div class="columns column6">
					<div class="title-reverse-wrapper">
						<h1>{{ page.title || page.header }}</h1>
						<h2 class="subtitle">{{ page.subtitle }}</h2>
					</div>
				</div>
				<div class="columns column6">
					<div class="columns column6">
						<p>
							<font-awesome-icon icon="fa-regular fa-location-dot" size="1x" />&nbsp;
							<strong>{{ defaults[locale].website.hotelName }}</strong>
							<br />
							<span>{{ defaults[locale].website.street }} {{ defaults[locale].website.number }}</span>
							<br />
							<span>{{ defaults[locale].website.postalCode }} {{ defaults[locale].website.city }}</span>
							<br />
							<span>{{ defaults[locale].website.country }}</span>
							<br />
							<a :href="`tel:${$phoneRaw(defaults[locale].website.phone)}`">
								<span>T: {{ defaults[locale].website.phone }}</span>
							</a>
							<br />
							<a :href="`mailto:${defaults[locale].website.email}`">
								<span>E: {{ defaults[locale].website.email }}</span>
								<br />
							</a>
							<span v-if="defaults[locale].website.btwNumber">
								{{ defaults[locale].website.btwNumber }}
								<br />
							</span>
							<span v-if="defaults[locale].website.kvkNumber">
								{{ defaults[locale].website.kvkNumber }}
								<br />
							</span>
							<span v-if="defaults[locale].website.bankDetails">
								{{ defaults[locale].website.bankDetails }}
							</span>
						</p>
					</div>
				</div>
			</template>
		</main-content>

		<section class="main-content background-light">
			<div class="row contact-form-row">
				<div class="columns column6 contact-form-col">
					<h2>{{ defaults[locale].website.contactFormHeader || $t('contactFormHeader') }}</h2>
					<contact-form name="contact" :form="form" />
				</div>
				<div class="columns column6 maps">
					<iframe
						id="maps"
						src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4874.204377748506!2d4.874351876939586!3d52.3504318487697!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c609f9ec595bcd%3A0x783cb404941e7f16!2sThe%20Delphi%20-%20Amsterdam%20Townhouse!5e0!3m2!1sen!2snl!4v1727250668916!5m2!1sen!2snl"
						width="100%"
						height="450"
						style="border: 0"
						allowfullscreen=""
						loading="lazy"
					/>
				</div>
			</div>
		</section>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();
await fetchDefaults();

const { data: form } = await useWebsiteFetch('contact', {
	query: { language: locale.value },
	key: `${locale.value}/contact`,
});
</script>

<style lang="scss" scoped>
.contact-form-row {
	background: var(--primary-background-color);
}

.contact-form-col {
	background: var(--primary-background-color);
	padding: 50px;
}

.maps {
	background: var(--primary-background-color);
	padding: 20px;
}

#maps {
	min-height: 600px;
}
</style>
